import { SimpleGrid, Text, Title, Group, Badge } from "@mantine/core";
import React from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import {
  formatDisplayValue,
  formatPhoneDisplay,
  isPhoneObject,
} from "../helpers/phoneUtils";
const FieldDisplay = ({
  title,
  titleTextSize,
  dataTextSize,
  value,
  render,
  dataFontWeight,
  t,
}) => {
  const isEmpty =
    value === null ||
    value === undefined ||
    value === "" ||
    (typeof value === "string" && !value.trim()) ||
    (isPhoneObject(value) && !formatPhoneDisplay(value));
  const displayValue = isEmpty ? "-" : formatDisplayValue(value);
  const isReactNode = React.isValidElement(value);

  return (
    <div>
      <Text size={titleTextSize} color={"dimmed"}>
        {t(title)}
      </Text>
      {_.isFunction(render) && render()}
      {!render && isReactNode && value}
      {!render && !isReactNode && (
        <Text
          size={dataTextSize}
          weight={dataFontWeight}
          style={{ whiteSpace: "pre-line" }}
        >
          {displayValue}
        </Text>
      )}
    </div>
  );
};
const ArrayDisplay = ({ title, titleTextSize, arr, t }) => (
  <div>
    <Text size={titleTextSize} color={"dimmed"}>
      {t(title)}
    </Text>

    <Group spacing={"xs"}>
      {_.isArray(arr) &&
        arr.map((c, index) => (
          <Badge key={index} radius={0} size="md">
            {t(c)}
          </Badge>
        ))}
    </Group>
    {_.isEmpty(arr) && <Text size={"xs"}>{"-"}</Text>}
  </div>
);
const InfoGridList = ({
  fields,
  cols = 3,
  spacing = "md",
  titleTextSize = "xs",
  dataTextSize = "sm",
  values,
  dataFontWeight = 600,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    !_.isEmpty(fields) &&
    values && (
      <SimpleGrid
        cols={cols}
        spacing={spacing}
        {...props}
        breakpoints={props.breakpoints}
      >
        {fields?.map(({ title, value, render, array, colSpan }, index) => (
          <div
            key={index}
            style={{ gridColumn: colSpan ? `span ${colSpan}` : undefined }}
          >
            {array ? (
              <ArrayDisplay
                title={title}
                arr={array}
                titleTextSize={titleTextSize}
                dataTextSize={dataTextSize}
                t={t}
              />
            ) : (
              <FieldDisplay
                title={title}
                value={value}
                render={render}
                dataFontWeight={dataFontWeight}
                titleTextSize={titleTextSize}
                dataTextSize={dataTextSize}
                t={t}
              />
            )}
          </div>
        ))}
      </SimpleGrid>
    )
  );
};

export default InfoGridList;
